import React, {
    useCallback,
    useEffect,
    useState
} from "react";

import { useNavigate } from "react-router-dom";


const AdminLive = () => {

    const navigate = useNavigate();

    const [lives, setLives] =
        useState([]);

    const [loading, setLoading] =
        useState(true);

    const [error, setError] =
        useState("");

    const [actionLoadingId, setActionLoadingId] =
        useState(null);


    const loadLives =
        useCallback(async () => {

            try {

                setLoading(true);
                setError("");

                const token =
                    localStorage.getItem(
                        "authToken"
                    );

                const authHeader =
                    token?.startsWith(
                        "Bearer "
                    )
                        ? token
                        : `Bearer ${token}`;


                const response =
                    await fetch(
                        `${process.env.REACT_APP_API_URL}/api/admin/live`,
                        {
                            headers: {
                                Authorization:
                                    authHeader
                            }
                        }
                    );


                if (!response.ok) {

                    throw new Error(
                        "Unable to load live sessions."
                    );
                }


                const data =
                    await response.json();


                setLives(
                    Array.isArray(data)
                        ? data
                        : []
                );


            } catch (error) {

                console.error(
                    "Admin live error:",
                    error
                );

                setError(
                    error.message ||
                    "Unable to load live sessions."
                );

            } finally {

                setLoading(false);
            }

        }, []);


    useEffect(() => {

        loadLives();

    }, [loadLives]);

    const stopLive = async (liveId) => {

        if (!liveId) {
            return;
        }

        const confirmed =
            window.confirm(
                "Stop this live session?"
            );

        if (!confirmed) {
            return;
        }

        try {

            setActionLoadingId(liveId);
            setError("");

            const token =
                localStorage.getItem(
                    "authToken"
                );

            const authHeader =
                token?.startsWith(
                    "Bearer "
                )
                    ? token
                    : `Bearer ${token}`;

            const response =
                await fetch(
                   `${process.env.REACT_APP_API_URL}/api/admin/live/${liveId}/stop`,
                    {
                        method: "PATCH",

                        headers: {
                            Authorization:
                                authHeader
                        }
                    }
                );

            const data =
                await response
                    .json()
                    .catch(() => ({}));

            if (!response.ok) {

                throw new Error(
                    data.message ||
                    "Unable to stop live."
                );
            }

            await loadLives();

        } catch (error) {

            console.error(
                "Stop live error:",
                error
            );

            setError(
                error.message ||
                "Unable to stop live."
            );

        } finally {

            setActionLoadingId(null);
        }
    };

    const formatDate =
        (value) => {

            if (!value) {
                return "-";
            }

            try {

                return new Date(
                    value
                ).toLocaleString();

            } catch {

                return value;
            }
        };


    return (

        <div
            style={{
                width: "100%",
                minHeight: "100vh",

                background:
                    "#f8f9fb",

                padding:
                    "30px",

                boxSizing:
                    "border-box"
            }}
        >

            <div
                style={{
                    maxWidth:
                        "1100px",

                    margin:
                        "0 auto"
                }}
            >

                <div
                    style={{
                        display:
                            "flex",

                        justifyContent:
                            "space-between",

                        alignItems:
                            "center",

                        marginBottom:
                            "24px",

                        gap:
                            "15px",

                        flexWrap:
                            "wrap"
                    }}
                >

                    <div>

                        <h1
                            style={{
                                margin: 0,
                                fontSize:
                                    "32px"
                            }}
                        >
                            Live Moderation
                        </h1>

                        <p
                            style={{
                                margin:
                                    "7px 0 0",

                                color:
                                    "#64748b"
                            }}
                        >
                            Monitor active live sessions
                        </p>

                    </div>


                    <button
                        type="button"

                        onClick={
                            loadLives
                        }

                        style={{
                            border:
                                "1px solid #d1d5db",

                            borderRadius:
                                "10px",

                            padding:
                                "10px 16px",

                            background:
                                "#fff",

                            cursor:
                                "pointer",

                            fontWeight:
                                "700"
                        }}
                    >
                        Refresh
                    </button>

                </div>


                {error && (

                    <div
                        style={{
                            marginBottom:
                                "20px",

                            padding:
                                "14px 16px",

                            borderRadius:
                                "12px",

                            background:
                                "#fef2f2",

                            border:
                                "1px solid #fecaca",

                            color:
                                "#b91c1c"
                        }}
                    >
                        {error}
                    </div>

                )}


                {loading ? (

                    <div
                        style={{
                            padding:
                                "40px",

                            textAlign:
                                "center",

                            background:
                                "#fff",

                            borderRadius:
                                "18px"
                        }}
                    >
                        Loading live sessions...
                    </div>

                ) : lives.length === 0 ? (

                    <div
                        style={{
                            padding:
                                "50px",

                            textAlign:
                                "center",

                            background:
                                "#fff",

                            borderRadius:
                                "18px",

                            color:
                                "#64748b"
                        }}
                    >

                        <div
                            style={{
                                fontSize:
                                    "36px",

                                marginBottom:
                                    "12px"
                            }}
                        >
                            📺
                        </div>

                        No active live sessions.

                    </div>

                ) : (

                    <div
                        style={{
                            display:
                                "grid",

                            gap:
                                "18px"
                        }}
                    >

                        {lives.map(
                            (live) => (

                                <div
                                    key={
                                        live.id
                                    }

                                    style={{
                                        background:
                                            "#fff",

                                        borderRadius:
                                            "18px",

                                        padding:
                                            "22px",

                                        boxShadow:
                                            "0 8px 25px rgba(15,23,42,.05)",

                                        border:
                                            "1px solid #eef2f7"
                                    }}
                                >

                                    <div
                                        style={{
                                            display:
                                                "flex",

                                            gap:
                                                "18px",

                                            alignItems:
                                                "flex-start",

                                            flexWrap:
                                                "wrap"
                                        }}
                                    >

                                        <img
                                            src={
                                                live.hostImage ||
                                                "/default-avatar.png"
                                            }

                                            alt={
                                                live.hostName ||
                                                "Host"
                                            }

                                            style={{
                                                width:
                                                    "72px",

                                                height:
                                                    "72px",

                                                borderRadius:
                                                    "50%",

                                                objectFit:
                                                    "cover",

                                                border:
                                                    "3px solid #f1f5f9"
                                            }}
                                        />


                                        <div
                                            style={{
                                                flex:
                                                    "1",

                                                minWidth:
                                                    "220px"
                                            }}
                                        >

                                            <div
                                                style={{
                                                    display:
                                                        "flex",

                                                    alignItems:
                                                        "center",

                                                    gap:
                                                        "10px",

                                                    flexWrap:
                                                        "wrap"
                                                }}
                                            >

                                                <h2
                                                    style={{
                                                        margin:
                                                            0,

                                                        fontSize:
                                                            "21px"
                                                    }}
                                                >
                                                    {live.hostName ||
                                                        "Unknown host"}
                                                </h2>


                                                <span
                                                    style={{
                                                        padding:
                                                            "5px 9px",

                                                        borderRadius:
                                                            "999px",

                                                        background:
                                                            "#fee2e2",

                                                        color:
                                                            "#dc2626",

                                                        fontSize:
                                                            "12px",

                                                        fontWeight:
                                                            "800"
                                                    }}
                                                >
                                                    ● LIVE
                                                </span>

                                            </div>


                                            <div
                                                style={{
                                                    marginTop:
                                                        "14px"
                                                }}
                                            >

                                                <strong>
                                                    {live.title ||
                                                        "Untitled live"}
                                                </strong>

                                            </div>


                                            {live.description && (

                                                <p
                                                    style={{
                                                        margin:
                                                            "7px 0 0",

                                                        color:
                                                            "#64748b",

                                                        lineHeight:
                                                            1.6
                                                    }}
                                                >
                                                    {live.description}
                                                </p>

                                            )}


                                            <div
                                                style={{
                                                    marginTop:
                                                        "15px",

                                                    display:
                                                        "flex",

                                                    gap:
                                                        "20px",

                                                    flexWrap:
                                                        "wrap",

                                                    fontSize:
                                                        "13px",

                                                    color:
                                                        "#64748b"
                                                }}
                                            >

                                                <span>
                                                    <strong>
                                                        Status:
                                                    </strong>{" "}
                                                    {live.status}
                                                </span>


                                                <span>
                                                    <strong>
                                                        Started:
                                                    </strong>{" "}
                                                    {formatDate(
                                                        live.startedAt
                                                    )}
                                                </span>

                                            </div>

                                        </div>


                                        <div
                                            style={{
                                                display:
                                                    "flex",

                                                gap:
                                                    "10px",

                                                flexWrap:
                                                    "wrap"
                                            }}
                                        >

                                            <button
                                                type="button"

                                                onClick={() =>
                                                    navigate(
                                                        `/admin/users/${live.hostId}`
                                                    )
                                                }

                                                style={{
                                                    padding:
                                                        "10px 15px",

                                                    borderRadius:
                                                        "10px",

                                                    border:
                                                        "1px solid #d1d5db",

                                                    background:
                                                        "#fff",

                                                    cursor:
                                                        "pointer",

                                                    fontWeight:
                                                        "700"
                                                }}
                                            >
                                                View User
                                            </button>


                                            <button
                                                type="button"

                                                disabled={
                                                    actionLoadingId ===
                                                    live.id
                                                }

                                                onClick={() =>
                                                    stopLive(
                                                        live.id
                                                    )
                                                }

                                                style={{
                                                    padding:
                                                        "10px 15px",

                                                    borderRadius:
                                                        "10px",

                                                    border:
                                                        "none",

                                                    background:
                                                        "#ef4444",

                                                    color:
                                                        "#fff",

                                                    cursor:
                                                        actionLoadingId ===
                                                            live.id
                                                            ? "not-allowed"
                                                            : "pointer",

                                                    fontWeight:
                                                        "800",

                                                    opacity:
                                                        actionLoadingId ===
                                                            live.id
                                                            ? 0.65
                                                            : 1
                                                }}
                                            >
                                                {actionLoadingId ===
                                                    live.id
                                                    ? "Stopping..."
                                                    : "Stop Live"}
                                            </button>

                                        </div>

                                    </div>

                                </div>

                            )
                        )}

                    </div>

                )}

            </div>

        </div>
    );
};


export default AdminLive;